export const OS_STATUS = {
  SCHEDULED: 'SCHEDULED',
  ACTIVE: 'ACTIVE',
}

export const OS_TAG = {
  [OS_STATUS.SCHEDULED]: {
    LABEL: 'Agendado',
    CLASS: '-scheduled',
  },
  [OS_STATUS.ACTIVE]: {
    LABEL: 'Em atendimento',
    CLASS: '-active',
  },
}

export const OS_CTA = {
  RESCHEDULE: 'RESCHEDULE',
  TRACK_VISIT: 'TRACK_VISIT',
}

export const OS_CTA_LABEL = {
  [OS_CTA.RESCHEDULE]: 'Reagendar atendimento',
  [OS_CTA.TRACK_VISIT]: 'Rastrear visita técnica',
  DEFAULT: 'Ok, entendi',
}

export const OS_CTA_TITLE = {
  [OS_CTA.RESCHEDULE]: 'Atendimento agendado',
  [OS_CTA.TRACK_VISIT]: 'Atendimento em andamento',
  DEFAULT: 'Atendimento agendado',
}
